import React, { Component } from "react";
import { LinkButton2 } from "../button/button";
import Clock from "../clock/clock";
import Navbar from "../navbar/navbar";
import icishmc from "../../images/icishmc.png";
import logo1 from "../../images/springer.jpg";
import logo2 from "../../images/acuminor.jpg";
// import logo from "../../images/logo.png";
import schedule from "./schedule.docx"
import vcmessage from "./vcmessage.jpeg"
import "./home.css";
export class Home extends Component {
  render() {
    return (
      <div className="header-area">
        <div id="home" className="header-content-area bg_cover">
          <Navbar />
          <div className=" d-flex align-items-center">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div className="header-content text-center">
                    <h2 className="header-title" style={{ marginTop: "15px" }}>
                      International Conference on Intelligent Systems and Human
                      Machine Collaboration 2022
                    </h2>
                    <h3 className="sub-title">
                      8<sup>th</sup> July - 9<sup>th</sup> July 2022
                    </h3>
                    {/* <h3
											className="sub-title1"
											style={{ animation: "blinker 1s linear infinite" }}
										>
											"to be held in virtual mode"
										</h3> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <img
                        className="home-header-logo1"
                        src={logo1}
                        alt="logo"
                      />
                      <img
                        className="home-header-logo1"
                        src={logo2}
                        alt="logo"
                      />
                    </div>
                    <div>
                      <img
                        className="home-header-logo1"
                        src="https://i.ibb.co/5668RS4/image.png"
                        alt="logo"
                      />
                      <img
                        className="home-header-logo"
                        src={icishmc}
                        alt="logo"
                      />
                      <img
                        className="home-header-logo1"
                        src="https://i.ibb.co/wdKgtKg/image.png"
                        alt="logo"
                      />
                    </div>
                    <h2 className="header-title-1">
                      Papers will be published by Springer as a proceedings book
                      volume of "Lecture Notes in Electrical Engineering"
                      (Scopus Indexed)
                    </h2> 
                    <div className="home-header-college">
                      <img
                        className="home-header-logo1"
                        src="https://i.ibb.co/Y2ngCTk/image.png"
                        alt="logo"
                      />

                      <h2 className="header-title">
                        Excelssior Education Society’s K. C. College of
                        Engineering and Management Studies and Research, Thane,
                        Maharashtra - 400603{" "}
                      </h2>
                    </div>

                    <Clock deadline="July, 9, 2022" />
                    {/* <ul className="header-btn">
                      <li>
                        <LinkButton2 label="Register now" link="/contact" />
                      </li>
                    </ul> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section id="about" className="about-area ">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="about-image ">
                  <img
                    src="https://preview.uideck.com/items/eventify/assets/images/about.png"
                    alt="About"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-content" style={{ textAlign: "justify" }}>
                  <div className="section-title">
                    <h2 className="title">About the Institute</h2>
                  </div>

                  <p className="text mt-30">
                    Excelssior Education Society (EES) is an educational and
                    charitable trust that is dedicated to the pursuit of
                    excellence and welfare of students since 1978. EES has a
                    group of institutions under its aegis, K.C. college of
                    engineering and Management Studies & Research, Thane being
                    one of them. It aims to maximize the capabilities of
                    individuals in all genres of life from being successful to
                    emerge as responsible citizens imbibing high moral and
                    ethical values. To embark on a journey of success, one needs
                    the tool of preparedness, foresight and strategy.
                  </p>
                  <br />
                  <ul className="header-btn">
                    <li>
                      <LinkButton2 label="Read More" link="/about" />
                    </li>
                  </ul>
                  <p className="date">
                    <span>
                      8<sup>th</sup>
                    </span>
                    July 2022-
                    <span>
                      9<sup>th</sup>
                    </span>
                    July 2022
                  </p>
                </div>
              </div>
            
            </div>
           <br />
           <div style={{display:"flex", justifyContent:"space-around"}}>
           <a href={schedule} download="ICISHMC 2022_final Schedule" target="_blank">
              <button class="main-btn main-btn-2">Conference schedule</button>
            </a>
            <a href={vcmessage} download="Message from VC" target="_blank">
              <button class="main-btn main-btn-2">Message from VC</button>
            </a>
           </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Home;
